import { render } from "./Emprestimo.vue?vue&type=template&id=330618ac&scoped=true"
import script from "./Emprestimo.vue?vue&type=script&lang=js"
export * from "./Emprestimo.vue?vue&type=script&lang=js"

import "./Emprestimo.vue?vue&type=style&index=0&id=330618ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330618ac"]])

export default __exports__